const ON_CHANGE_DEBOUNCE_TIMER = 300;


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('cart-vat')) {
  customElements.define(
    'cart-vat',
    class CartVat extends HTMLElement {
      constructor() {
        super();

        this.setCheckboxToggler()

        this.querySelector("#vatInput").addEventListener(
            'input',
            debounce((event) => {
              const body = JSON.stringify({ attributes: { [event.target.name]: event.target.value } });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, ON_CHANGE_DEBOUNCE_TIMER)
          );
      }
      flushInputs(){
        this.querySelectorAll("input[type='text']").forEach(input => {
          input.value = "";
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
          return
        })
      }
      setCheckboxToggler(){
        const elementToToggle = this.querySelector("#vat_input");
        const checkboxEl = this.querySelector("#vat_checkbox");
      
        checkboxEl.addEventListener("input", (e) => {
          const isChecked = e.target.checked;
      
          elementToToggle.classList.remove("hidden");
          
      
          if (!isChecked) {
            elementToToggle.classList.add("hidden");
            this.flushInputs();
          }
        });
      }
    }
  );
}